import { Injectable } from '@angular/core';
import { UserDataStore, UserDataQuery } from '../states/user-data/index.js';

@Injectable({ providedIn: 'root' })
export class UserDataFacade {
  invitedUserNumber$ = this.userDataQuery.select((state) => state.invitedUsers.filter((u) => u.status === 1).length);
  invitedUsers$ = this.userDataQuery.select((state) => state.invitedUsers);
  eventsResults$ = this.userDataQuery.select((state) => state.eventsResults);
  constructor(public userDataStore: UserDataStore, public userDataQuery: UserDataQuery) {}

  setInvitedUsers(invitedUsers: any[]) {
    this.userDataStore.update({ invitedUsers: invitedUsers });
  }

  getInvitedUsers() {
    return this.userDataQuery.getValue().invitedUsers;
  }

  setEventResults(eventsResults: any[]) {
    this.userDataStore.update({ eventsResults: eventsResults });
  }
}
